/* AI相談 引き継ぎ (畳み込みなしページ用)
   ゲーム選択ページから ?games=valorant,apex で渡された選択を診断側へ反映する。
   - 畳み込みUI(tg-gss-consult.js)は使わない前提の軽量版
   - 反映は既存タイルの click() シミュレーション (診断ロジックは直接触らない・冪等)
   - 診断側に実在する data-gk のみ通す (不正値・重複は捨てる) */
(function () {
  var raw = new URLSearchParams(location.search).get('games');
  var usage = new URLSearchParams(location.search).get('usage');
  if (!raw) return;

  function showSelection(scope, labels, wanted) {
    var existing = scope.querySelector('.gs-carried-summary');
    if (existing) existing.remove();
    var summary = document.createElement('div');
    summary.className = 'gs-carried-summary';
    summary.setAttribute('role', 'status');
    var copy = document.createElement('div');
    var caption = document.createElement('span');
    caption.textContent = '選択中のゲーム';
    var names = document.createElement('strong');
    names.textContent = labels.join('、');
    copy.appendChild(caption);
    copy.appendChild(names);
    var change = document.createElement('button');
    change.type = 'button';
    change.textContent = '変更する';
    change.addEventListener('click', function () {
      var expand = document.getElementById('gsGameExpand');
      var hasHiddenSelection = wanted.some(function (key) {
        var tile = Array.prototype.find.call(document.querySelectorAll('#wzGames [data-gk]'), function (candidate) {
          return candidate.dataset.gk === key;
        });
        return tile && tile.getAttribute('data-extra') === '1';
      });
      if (hasHiddenSelection && expand && expand.getAttribute('aria-expanded') !== 'true') expand.click();
      if (typeof window.__gsWizGo === 'function') window.__gsWizGo(1);
    });
    summary.appendChild(copy);
    summary.appendChild(change);
    var top = scope.querySelector('.gs-wiz__top');
    if (top && top.parentNode) top.parentNode.insertBefore(summary, top.nextSibling);
  }

  function apply() {
    var tiles = document.querySelectorAll('#wzGames [data-gk]');
    if (!tiles.length) return false;

    var valid = {};
    tiles.forEach(function (t) { valid[t.dataset.gk] = t; });

    var wanted = [];
    raw.split(',').forEach(function (k) {
      k = k.trim();
      if (valid.hasOwnProperty(k) && wanted.indexOf(k) < 0) wanted.push(k);
    });
    if (!wanted.length) return true;   /* 不正値のみ: 何もせず終了 */

    tiles.forEach(function (t) {
      var want = wanted.indexOf(t.dataset.gk) >= 0;
      var has = t.classList.contains('on');
      if (want !== has) t.click();
    });
    var scope = document.querySelector('.tg-gss-scope');
    if (scope) {
      var labels = wanted.map(function (key) {
        return valid[key].getAttribute('aria-label') || valid[key].textContent.trim() || key;
      });
      scope.setAttribute('data-selection-carried', 'true');
      scope.setAttribute('data-carried-game-count', String(wanted.length));
      showSelection(scope, labels, wanted);
      if (usage === 'gaming_only' && typeof window.__gsWizGo === 'function') window.__gsWizGo(2);
    }
    return true;
  }

  /* タイルは診断側JSが生成するため、出現を待ってから適用する */
  var tries = 0;
  (function wait() {
    if (apply()) return;
    if (++tries > 40) return;          /* 約4秒であきらめる */
    setTimeout(wait, 100);
  })();
})();
